import { buildModelManager } from "../builder.js";
const DefaultQaProcessingEventSelection = {
  __typename: true,
  id: true,
  chartId: true,
  createdAt: true,
  details: true,
  stage: true,
  status: true,
  updatedAt: true,
  workflowId: true
};
const modelApiIdentifier = "qaProcessingEvent";
const pluralModelApiIdentifier = "qaProcessingEvents";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQaProcessingEventSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultQaProcessingEventSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaProcessingEventSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaProcessingEventSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultQaProcessingEventSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQaProcessingEventSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultQaProcessingEventSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "qaProcessingEventGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const QaProcessingEventManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultQaProcessingEventSelection,
  operations
);
export {
  DefaultQaProcessingEventSelection,
  QaProcessingEventManager
};
//# sourceMappingURL=QaProcessingEvent.js.map
